export const HOME_MENU_ID = 'Z999999999';
